import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Config } from '../../common/config';
import axios from 'axios';
import AlertModal from '../../components/alertModal';
import { getPostcode } from '../../components/zip';
import { translations } from '../../data/translation'; // Import the translations
import { useSelector, useDispatch } from 'react-redux';
import { userLogin1 } from '../../reducers/userInfo1';

export default function UserContent(props) {
  const language = useSelector(state => state.language.language);
  const t = translations[language];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  var script = document.createElement('script');
  script.src = '//t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';

  document.head.appendChild(script);

  const today = new Date().toISOString().split('T')[0];

  const preventSubmit = event => {
    event.preventDefault();
  };

  const [modalOpen, setModalOpen] = useState(false); //모달 상태 관리 : 기본값 - 닫힘
  const [modalInfo, setModalInfo] = useState({
    isCancel: false,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '',
    action: '',
    isPercent: false,
  });
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [birthday, setBirthday] = useState('');
  const [email, setEmail] = useState('');
  const [gender, setGender] = useState('M');
  const [, setEmailAuthNo] = useState(0);
  const [emailAuthNoInput, setEmailAuthNoInput] = useState('');
  const [sms1, setSms1] = useState('');
  const [sms2, setSms2] = useState('');
  const [sms3, setSms3] = useState('');
  const [, setMobileAuthNo] = useState(0);
  const [mobileAuthNoInput, setMobileAuthNoInput] = useState('');
  const [verifyId, setVerifyId] = useState(false);
  const [verifySamePassword, setVerifySamePassword] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [verifySMS, setVerifySMS] = useState(false);
  const [acceptAgree, setAcceptAgree] = useState('RA001');
  const [detailAddr, setDetailAddr] = useState('');
  const [useSamePhoneForStore, setUseSamePhoneForStore] = useState(false);
  const [useSameAddrForStore, setUseSameAddrForStore] = useState(false);
  const useSamePhoneForStoreRef = useRef(false);
  const useSameAddrForStoreRef = useRef(false);
  useSamePhoneForStoreRef.current = useSamePhoneForStore;
  useSameAddrForStoreRef.current = useSameAddrForStore;

  const [idHint, setIdHint] = useState('');
  const [passwordHint, setPasswordHint] = useState('');
  const [idInvalid, setIdInvalid] = useState(false);
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [nameHint, setNameHint] = useState('');
  const [emailHint, setEmailHint] = useState('');
  const [emailCodeHint, setEmailCodeHint] = useState('');
  const [phoneHint, setPhoneHint] = useState('');
  const [phoneCodeHint, setPhoneCodeHint] = useState('');

  const openModal = e => {
    // 수신동의 체크
    if (acceptAgree !== 'RA001') {
      setModalInfo({
        ...modalInfo,
        mainMsg: t.agreeRequired,
        isConfirm: true,
        isCancel: false,
      });
      setModalOpen(true);
      return;
    }
    if (modalInfo.actionFlag === 'id1') {
      setModalInfo({ ...modalInfo, mainMsg: t.idRuleHint });
    } else if (modalInfo.actionFlag === 'id2') {
      setModalInfo({ ...modalInfo, mainMsg: t.idDuplicate });
    } else if (modalInfo.actionFlag === 'verifyId') {
      setModalInfo({ ...modalInfo, mainMsg: t.idCheckRequired });
    } else if (modalInfo.actionFlag === 'password') {
      setModalInfo({ ...modalInfo, mainMsg: t.passwordRule });
    } else if (modalInfo.actionFlag === 'verifySamePassword') {
      setModalInfo({ ...modalInfo, mainMsg: t.passwordMismatch });
    } else if (modalInfo.actionFlag === 'mail') {
      setModalInfo({ ...modalInfo, mainMsg: t.sendingEmail });
    } else if (modalInfo.actionFlag === 'getEmailAuth') {
      setModalInfo({ ...modalInfo, mainMsg: t.emailAuthGetRequired });
    } else if (modalInfo.actionFlag === 'verifyEmailError') {
      setModalInfo({ ...modalInfo, mainMsg: t.emailAuthError });
    } else if (modalInfo.actionFlag === 'verifyEmail') {
      setModalInfo({ ...modalInfo, mainMsg: t.verifyEmail });
    } else if (modalInfo.actionFlag === 'SMS') {
      setModalInfo({ ...modalInfo, mainMsg: t.sendingSms });
    } else if (modalInfo.actionFlag === 'getSMSAuth') {
      setModalInfo({ ...modalInfo, mainMsg: t.smsAuthGetRequired });
    } else if (modalInfo.actionFlag === 'verifySMSError') {
      setModalInfo({ ...modalInfo, mainMsg: t.smsAuthError });
    } else if (modalInfo.actionFlag === 'verifySMS') {
      setModalInfo({ ...modalInfo, mainMsg: t.verifySMS });
    } else if (modalInfo.actionFlag === 'api') {
      setModalInfo({ ...modalInfo, mainMsg: t.apiError });
    } else if (modalInfo.actionFlag === 'name') {
      setModalInfo({ ...modalInfo, mainMsg: t.nameRequired });
    } else if (modalInfo.actionFlag === 'email') {
      setModalInfo({ ...modalInfo, mainMsg: t.emailRequired });
    }

    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const doModal = () => {
    if (modalInfo.actionFlag === 'redirectToStore') {
      navigate('/store-content', { replace: true });
    }
    setModalOpen(false);
  };

  const validateId = () => {
    if (id.length === 0 || id.length < 5 || id.length > 15) {
      setIdInvalid(true);
      modalInfo.actionFlag = 'id1';
      openModal();
      return;
    }

    // 영문 소문자와 숫자만 포함하는지 확인
    let hasLowerCase = false;

    for (let i = 0; i < id.length; i++) {
      const char = id.charAt(i);

      if (char >= 'a' && char <= 'z') {
        hasLowerCase = true;
      } else if (char >= '0' && char <= '9') {
        // 숫자는 허용
        continue;
      } else {
        // 영문 소문자나 숫자가 아닌 문자가 있으면 에러
        setIdInvalid(true);
        modalInfo.actionFlag = 'id1';
        openModal();
        return;
      }
    }

    if (!hasLowerCase) {
      setIdInvalid(true);
      modalInfo.actionFlag = 'id1';
      openModal();
      return;
    } else {
      setIdInvalid(false);
      return true;
    }
  };

  // 비밀번호 형식 유효 여부만 반환 (8~16자, 영문·숫자·특수문자 중 2가지 이상, 영문 필수)
  const isValidPasswordFormat = pwd => {
    if (!pwd || pwd.length < 8 || pwd.length > 16) return false;
    let hasLetter = false;
    let hasNumber = false;
    let hasSpecialChar = false;
    const specialChars = '!"#$%&\'()*+,-./:;>=<?@[\\]^_`{|}~';
    for (let i = 0; i < pwd.length; i++) {
      const char = pwd.charAt(i);
      if ((char >= 'a' && char <= 'z') || (char >= 'A' && char <= 'Z')) {
        hasLetter = true;
      } else if (char >= '0' && char <= '9') {
        hasNumber = true;
      } else if (specialChars.includes(char)) {
        hasSpecialChar = true;
      }
    }
    const typeCount =
      (hasLetter ? 1 : 0) + (hasNumber ? 1 : 0) + (hasSpecialChar ? 1 : 0);
    if (typeCount < 2 || !hasLetter) return false;
    // 동일한 문자가 3번 이상 연속으로 나오는지 확인
    for (let i = 0; i < pwd.length - 2; i++) {
      if (pwd[i] === pwd[i + 1] && pwd[i] === pwd[i + 2]) {
        return false;
      }
    }
    return true;
  };

  const validatePassword = () => {
    if (!isValidPasswordFormat(password)) {
      setPasswordInvalid(true);
      modalInfo.actionFlag = 'password';
      openModal();
    } else {
      setPasswordInvalid(false);
    }
  };

  const validateSamePassword = pwd => {
    if (password !== pwd) {
      modalInfo.actionFlag = 'verifySamePassword';
      openModal();
    } else {
      setVerifySamePassword(true);
    }
  };

  const idCkeck = async () => {
    const result = validateId();
    if (result) {
      const data = { adminId: id };
      const ret = await axios.post(
        `${process.env.REACT_APP_API_SERVER_ADMIN}idCheck`,
        data
      );
      if (ret.data.data.dupResult) {
        setIdInvalid(true);
        modalInfo.actionFlag = 'id2';
        openModal();
      } else {
        setIdInvalid(false);
        setVerifyId(true);
        setModalInfo({ ...modalInfo, mainMsg: t.idAvailable });
        setModalOpen(true);
      }
    }
  };

  const getEmailAuthNo = async () => {
    if (verifyId) {
      if (verifySamePassword) {
        if (name && email) {
          const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!regex.test(email)) {
            setModalInfo({
              ...modalInfo,
              mainMsg: t.emailInvalid,
            });
            setModalOpen(true);
            return;
          }
          modalInfo.actionFlag = 'mail';
          modalInfo.isConfirm = false;
          openModal();
          const data = {
            adminId: id,
            adminName: name,
            password: password,
            email,
          };
          const ret = await axios.post(
            `${process.env.REACT_APP_API_SERVER_ADMIN}mail/send-nc-mail`,
            data
          );
          if (ret.data.data.emailAuthNo) {
            setEmailAuthNo(ret.data.data.emailAuthNo);
            setEmailAuthNoInput('');
            setModalOpen(false);
            setModalInfo({
              ...modalInfo,
              isConfirm: true,
              mainMsg: t.emailAuthCheck,
            });
            setModalOpen(true);
          } else {
            // API 에러...
            setModalOpen(false);
            modalInfo.actionFlag = 'api';
            modalInfo.isConfirm = true;
            openModal();
          }
        } else {
          if (!name) {
            modalInfo.actionFlag = 'name';
            openModal();
          } else if (!email) {
            modalInfo.actionFlag = 'email';
            openModal();
          }
        }
      } else {
        modalInfo.actionFlag = 'verifySamePassword';
        openModal();
      }
    } else {
      modalInfo.actionFlag = 'verifyId';
      openModal();
    }
  };

  const validateEmail = () => {
    // 빈 문자열 검사
    if (!email) {
      modalInfo.mainMsg = t.emailEmptyHint;
      setModalOpen(true);
    }

    // 문자열 형식 검사
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regex.test(email)) {
      modalInfo.mainMsg = t.emailInvalid;
      setModalOpen(true);
    }
  };

  const validateEmailAuthNo = async () => {
    if (emailAuthNoInput && Number(emailAuthNoInput) > 0) {
      const data = { adminId: id, emailAuthNo: Number(emailAuthNoInput) };
      const ret = await axios.post(
        `${process.env.REACT_APP_API_SERVER_ADMIN}mail/verifyEmail`,
        data
      );
      if (ret?.data?.data?.verifyResult) {
        setVerifyEmail(true);
        setModalInfo({
          ...modalInfo,
          mainMsg: t.emailAuthSuccess,
        });
        setModalOpen(true);
      } else {
        // API 에러...
        modalInfo.actionFlag = 'verifyEmailError';
        openModal();
      }
    } else {
      modalInfo.actionFlag = 'getEmailAuth';
      openModal();
    }
  };

  const validateSMS = () => {
    const hasNumber1 = !isNaN(sms1) && sms1.length > 0;
    const hasNumber2 = !isNaN(sms2) && sms2.length > 0;
    const hasNumber3 = !isNaN(sms3) && sms3.length > 0;
    if (!hasNumber1 || !hasNumber2 || !hasNumber3) {
      modalInfo.mainMsg = t.phoneFormat;
      return false;
    }
    const isMobile = sms1 === '010' && sms2.length === 4 && sms3.length === 4;
    const isSeoul =
      sms1 === '02' &&
      (sms2.length === 3 || sms2.length === 4) &&
      sms3.length === 4;
    const isLocal =
      sms1.length === 3 &&
      sms1 !== '010' &&
      sms2.length === 3 &&
      sms3.length === 4;

    if (isMobile || isSeoul || isLocal) {
      return true;
    }
    modalInfo.mainMsg = t.phoneFormat;
    return false;
  };

  const getSMSAuthNo = async () => {
    if (verifyId) {
      if (verifySamePassword) {
        if (verifyEmail) {
          const validSMS = validateSMS();
          if (validSMS) {
            const sms = sms1 + '-' + sms2 + '-' + sms3;
            const data = { adminId: id, password: password, mobile: sms };
            const ret = await axios.post(
              `${process.env.REACT_APP_API_SERVER_ADMIN}mail/send-sms`,
              data
            );
            if (ret?.data?.data?.mobileAuthNo) {
              setMobileAuthNo(ret.data.data.mobileAuthNo);
              setMobileAuthNoInput('');
              setModalInfo({
                ...modalInfo,
                mainMsg: t.smsAuthCheck,
              });
              setModalOpen(true);
            } else {
              // API 에러...
              modalInfo.actionFlag = 'api';
              openModal();
            }
          } else {
            setModalInfo({ ...modalInfo });
            setModalOpen(true);
          }
        } else {
          modalInfo.actionFlag = 'verifyEmail';
          openModal();
        }
      } else {
        modalInfo.actionFlag = 'verifySamePassword';
        openModal();
      }
    } else {
      modalInfo.actionFlag = 'verifyId';
      openModal();
    }
  };

  const validateSMSAuthNo = async () => {
    if (mobileAuthNoInput && Number(mobileAuthNoInput) > 0) {
      const data = { adminId: id, mobileAuthNo: Number(mobileAuthNoInput) };
      const ret = await axios.post(
        `${process.env.REACT_APP_API_SERVER_ADMIN}mail/verifySms`,
        data
      );
      if (ret.data.data.verifyResult) {
        setVerifySMS(true);
        setModalInfo({
          ...modalInfo,
          mainMsg: t.smsAuthSuccess,
        });
        setModalOpen(true);
      } else {
        // API 에러...
        modalInfo.actionFlag = 'verifySMSError';
        openModal();
      }
    } else {
      modalInfo.actionFlag = 'getSMSAuth';
      openModal();
    }
  };

  // 체크박스 클릭 핸들러
  const handleCheckbox = value => {
    setAcceptAgree(value);
  };

  const checkUserData = () => {
    if (!id) {
      modalInfo.mainMsg = t.idRequired;
      return false;
    }
    if (!verifyId) {
      modalInfo.mainMsg = t.idCheckRequired;
      return false;
    }
    if (!password) {
      modalInfo.mainMsg = t.passwordRequired;
      return false;
    }
    if (!isValidPasswordFormat(password)) {
      setPasswordInvalid(true);
      modalInfo.actionFlag = 'password';
      modalInfo.mainMsg = t.passwordRule;
      return false;
    }
    if (!verifySamePassword) {
      modalInfo.mainMsg = t.passwordConfirmRequired;
      return false;
    }
    if (!name) {
      modalInfo.mainMsg = t.nameRequired;
      return false;
    }
    if (!birthday) {
      modalInfo.mainMsg = t.birthdayRequired;
      return false;
    }
    if (!verifyEmail) {
      modalInfo.mainMsg = t.emailAuthRequired;
      return false;
    }
    if (!verifySMS) {
      modalInfo.mainMsg = t.smsAuthRequired;
      return false;
    }

    const postcodeEl = document.getElementById('postcode');
    const roadEl = document.getElementById('roadAddress');
    const jibunEl = document.getElementById('jibunAddress');
    if (!postcodeEl?.value?.trim()) {
      modalInfo.mainMsg = t.postalCodeRequired;
      return false;
    }
    if (!roadEl?.value?.trim()) {
      modalInfo.mainMsg = t.roadAddressRequired;
      return false;
    }
    if (!jibunEl?.value?.trim()) {
      modalInfo.mainMsg = t.jibunAddressRequired;
      return false;
    }
    if (!detailAddr || detailAddr.trim().length === 0) {
      modalInfo.mainMsg = t.detailAddrRequired;
      return false;
    }

    return true;
  };

  const goRegister = async () => {
    try {
      // 수신동의 체크
      if (acceptAgree !== 'RA001') {
        setModalInfo({
          ...modalInfo,
          mainMsg: t.agreeRequired,
          isConfirm: true,
          isCancel: false,
        });
        setModalOpen(true);
        return;
      }
      if (!checkUserData()) {
        setModalOpen(true);
        return;
      }

      const storeData = JSON.parse(
        localStorage.getItem('totalStoreData') || '{}'
      );
      if (!storeData.storeName || !storeData.phone || !storeData.bankCode) {
        setModalInfo({
          ...modalInfo,
          mainMsg: t.storeDataRequired,
          isConfirm: true,
          isCancel: false,
        });
        setModalOpen(true);
        return;
      }

      const imageFile = location.state?.imageFile || null;
      const bizCertFile = location.state?.bizCertFile || null;
      const userZip = document.getElementById('postcode')?.value || '';
      const userAddr = document.getElementById('roadAddress')?.value || '';
      const userDetailAddr =
        document.getElementById('detailAddress')?.value || detailAddr;

      const usePhone = useSamePhoneForStoreRef.current;
      const useAddr = useSameAddrForStoreRef.current;
      // 체크 시: totalStoreData(상점) 값을 사용 - 관리자 정보도 상점과 동일하게 적용
      const adminPhone = usePhone
        ? storeData.phone
        : sms1 + '-' + sms2 + '-' + sms3;
      const adminZip = useAddr ? storeData.zipCode || '' : userZip;
      const adminAddr = useAddr ? storeData.addr || '' : userAddr;
      const adminDetAddr = useAddr
        ? storeData.detailAddr || ''
        : userDetailAddr;
      // 상점 정보는 항상 totalStoreData 사용
      const storePhone = storeData.phone;
      const storeZipCode = storeData.zipCode || '';
      const storeAddr = storeData.addr || '';
      const storeDetAddr = storeData.detailAddr || '';

      const formData = new FormData();
      formData.append('adminId', id);
      formData.append('password', password);
      formData.append('adminName', name);
      formData.append('role', 'AG001');
      formData.append('birthday', birthday);
      formData.append('gender', gender);
      formData.append('email', email);
      formData.append('mobile', adminPhone);
      formData.append('zipCode', adminZip);
      formData.append('addr', adminAddr);
      formData.append('detAddr', adminDetAddr);
      formData.append('acceptAgree', acceptAgree);

      formData.append('storeName', storeData.storeName);
      formData.append('representativeName', storeData.representativeName || '');
      formData.append('phone', storePhone);
      formData.append('storeZipCode', storeZipCode);
      formData.append('storeAddr', storeAddr);
      formData.append('storeDetAddr', storeDetAddr);
      formData.append('bankCode', storeData.bankCode);
      formData.append('accountNo', storeData.accountNo);
      formData.append('accountHolder', storeData.accountHolder);
      formData.append('bizNum', storeData.bizNum || '1');
      formData.append('bizType', storeData.bizType || 'BT002');
      formData.append('repStoreYn', storeData.repStoreYn || 'N');
      formData.append('naverUrl', storeData.naverUrl || '');
      formData.append('kakaoUrl', storeData.kakaoUrl || '');
      formData.append('instagramUrl', storeData.instagramUrl || '');
      formData.append(
        'ageRestriction',
        storeData.ageRestriction || '전체 이용가'
      );
      if (storeData.storeNo != null) {
        formData.append('storeNo', String(storeData.storeNo));
      }
      if (imageFile) {
        formData.append('file', imageFile);
      }
      if (bizCertFile) {
        formData.append('bizCertFile', bizCertFile);
      }

      modalInfo.actionFlag = 'register';
      modalInfo.isConfirm = false;
      modalInfo.mainMsg = t.storeRegistering;
      setModalInfo({ ...modalInfo });
      setModalOpen(true);

      const ret = await axios.post(
        `${process.env.REACT_APP_API_SERVER_ADMIN}register-complete`,
        formData,
        { withCredentials: true }
      );

      setModalOpen(false);

      const data = ret?.data?.data?.data ?? ret?.data?.data;
      if (data?.storeNo) {
        // 회원가입 완료 이메일/SMS는 register-complete API에서 자동 발송됨
        localStorage.removeItem('totalStoreData');
        localStorage.removeItem('totalUserData');
        dispatch(userLogin1({ id, name }));
        navigate('/user-confirm');
      } else {
        modalInfo.actionFlag = 'api';
        modalInfo.mainMsg = t.apiError;
        setModalInfo({ ...modalInfo });
        setModalOpen(true);
      }
    } catch (error) {
      setModalOpen(false);
      if (error.response) {
        modalInfo.actionFlag = 'api';
        modalInfo.mainMsg = t.apiError;
        setModalInfo({ ...modalInfo });
        setModalOpen(true);
      } else if (error.request) {
        modalInfo.actionFlag = 'api';
        modalInfo.mainMsg = t.apiError;
        setModalInfo({ ...modalInfo });
        setModalOpen(true);
      } else {
        modalInfo.actionFlag = 'api';
        modalInfo.mainMsg = t.apiError;
        setModalInfo({ ...modalInfo });
        setModalOpen(true);
      }
      console.error('Error fetching data:', error);
    }
  };

  const cancelUser = async () => {
    try {
      if (id.length > 0) {
        const cancelData = { userId: id };
        await axios.put(`${Config.API_SERVER}admin/pro`, cancelData);
      }

      navigate('/');
    } catch (error) {
      if (error.response) {
        modalInfo.actionFlag = 'api';
        openModal();
      } else if (error.request) {
        modalInfo.actionFlag = 'api';
        openModal();
      } else {
        modalInfo.actionFlag = 'api';
        openModal();
      }
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    const storeData = JSON.parse(
      localStorage.getItem('totalStoreData') || '{}'
    );
    if (!storeData.storeName || !storeData.phone || !storeData.bankCode) {
      setModalInfo(prev => ({
        ...prev,
        actionFlag: 'redirectToStore',
        mainMsg: t.storeDataRedirectMsg,
        isConfirm: true,
        isMessage: true,
      }));
      setModalOpen(true);
    }
  }, [navigate, t.storeDataRedirectMsg]);

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        action={doModal}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
      >
        {modalInfo.mainMsg}
      </AlertModal>

      <section className="location_box">
        <ul className="location_001">
          <li>{t.home}</li>
          <li>{t.signup}</li>
          <li>{t.adminInfo}</li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_02">
          <h2 className="tit_01">{t.signupPage}</h2>

          <article className="signup_03">
            <h3 className="tit_02">{t.adminInfo}</h3>
            <p>{t.enterAdminInfo}</p>
          </article>

          <article className="contants_box_03">
            <table className="member_box">
              <tbody>
                <tr>
                  <th>{t.id}</th>
                  <td>
                    <form onSubmit={preventSubmit}>
                      <div
                        className={`input_inline_wrapper ${idInvalid ? 'input_wrapper_invalid' : ''}`}
                      >
                        <input
                          className="input_01"
                          type="text"
                          name=""
                          placeholder={t.idPlaceholder}
                          maxLength={15}
                          onChange={e => {
                            const raw = e.target.value || '';
                            const filtered = raw
                              .toLowerCase()
                              .replace(/[^a-z0-9]/g, '');
                            setIdInvalid(false);
                            setIdHint(raw !== filtered ? t.idFormatHint : '');
                            setId(filtered);
                          }}
                          value={id}
                          onBlur={validateId}
                        />
                        {idInvalid && (
                          <span className="input_invalid_label">
                            {t.inputInvalid}
                          </span>
                        )}
                      </div>
                      <button
                        type="button"
                        className="button_05 button_gray"
                        onClick={idCkeck}
                      >
                        {t.duplicateCheck}
                      </button>
                      {idHint && <p className="font_red">{idHint}</p>}
                      <p
                        className={idInvalid ? 'font_red' : ''}
                        style={{
                          fontSize: '12px',
                          color: idInvalid ? undefined : '#666',
                          marginTop: '4px',
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {t.idRuleHint}
                      </p>
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.password}</th>
                  <td>
                    <form onSubmit={preventSubmit}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <div
                          className={
                            passwordInvalid ? 'input_wrapper_invalid' : ''
                          }
                          style={{ flex: 1 }}
                        >
                          <input
                            className="input_01"
                            type={showPassword ? 'text' : 'password'}
                            name=""
                            placeholder=""
                            maxLength={16}
                            onChange={e => {
                              const raw = e.target.value || '';
                              const filtered = raw.replace(/[^\x21-\x7E]/g, '');
                              setPasswordInvalid(false);
                              setPasswordHint(
                                raw !== filtered ? t.passwordFormatHint : ''
                              );
                              setPassword(filtered);
                            }}
                            value={password}
                            onBlur={validatePassword}
                          />
                          {passwordInvalid && (
                            <span className="input_invalid_label">
                              {t.inputInvalid}
                            </span>
                          )}
                        </div>
                        <button
                          type="button"
                          onClick={() => setShowPassword(v => !v)}
                          aria-label={
                            showPassword ? '비밀번호 숨기기' : '비밀번호 보기'
                          }
                          style={{
                            border: 'none',
                            background: 'transparent',
                            cursor: 'pointer',
                            fontSize: 16,
                            lineHeight: 1,
                            padding: 0,
                          }}
                        >
                          {showPassword ? (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                          ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" /><circle cx="12" cy="12" r="3" /></svg>
                          )}
                        </button>
                      </div>
                      {passwordHint && (
                        <p className="font_red">{passwordHint}</p>
                      )}
                      <p
                        className={passwordInvalid ? 'font_red' : ''}
                        style={{
                          fontSize: '12px',
                          color: passwordInvalid ? undefined : '#666',
                          marginTop: '4px',
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {t.passwordRule}
                      </p>
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.confirmPassword}</th>
                  <td>
                    <form onSubmit={preventSubmit}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <input
                          className="input_01"
                          type={showConfirmPassword ? 'text' : 'password'}
                          name=""
                          placeholder=""
                          maxLength={16}
                          onBlur={e => {
                            validateSamePassword(e.target.value);
                          }}
                          style={{ flex: 1 }}
                        />
                        <button
                          type="button"
                          onClick={() => setShowConfirmPassword(v => !v)}
                          aria-label={
                            showConfirmPassword
                              ? '비밀번호 숨기기'
                              : '비밀번호 보기'
                          }
                          style={{
                            border: 'none',
                            background: 'transparent',
                            cursor: 'pointer',
                            fontSize: 16,
                            lineHeight: 1,
                            padding: 0,
                          }}
                        >
                          {showConfirmPassword ? (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                          ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" /><circle cx="12" cy="12" r="3" /></svg>
                          )}
                        </button>
                      </div>
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.name}</th>
                  <td>
                    <form onSubmit={preventSubmit}>
                      <input
                        className="input_01"
                        type="text"
                        name=""
                        maxLength={80}
                        onChange={e => {
                          const raw = e.target.value || '';
                          const filtered = raw.replace(/[0-9]/g, '');
                          setNameHint(raw !== filtered ? t.nameNoNumber : '');
                          setName(filtered);
                        }}
                        value={name}
                      />
                      {nameHint && <p className="font_red">{nameHint}</p>}
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.birthday}</th>
                  <td>
                    <form onSubmit={preventSubmit}>
                      <input
                        className="input_01"
                        type="date"
                        name=""
                        min="1900-01-01"
                        max={today}
                        inputMode="none"
                        onKeyDown={e => e.preventDefault()}
                        onPaste={e => e.preventDefault()}
                        onDrop={e => e.preventDefault()}
                        onFocus={e => {
                          if (e.target.showPicker) {
                            e.target.showPicker();
                          }
                        }}
                        onChange={e => {
                          setBirthday(e.target.value);
                        }}
                      />
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.gender}</th>
                  <td>
                    <form onSubmit={preventSubmit}>
                      <select
                        className="input_01"
                        name="gender"
                        onChange={e => {
                          setGender(e.target.value);
                        }}
                        value={gender}
                      >
                        {/* <option value="" disabled>선택</option> */}
                        <option value="M">{t.male}</option>
                        <option value="F">{t.female}</option>
                      </select>
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.email}</th>
                  <td>
                    <form onSubmit={preventSubmit}>
                      <input
                        className="input_01"
                        type="text"
                        name=""
                        placeholder={t.emailPlaceholder}
                        maxLength={80}
                        onChange={e => {
                          const raw = e.target.value || '';
                          const filtered = raw.replace(/\s+/g, '');
                          setEmailHint(
                            raw !== filtered ? t.emailSpaceHint : ''
                          );
                          setEmail(filtered);
                        }}
                        value={email}
                        onBlur={e => {
                          validateEmail(e.target.value);
                        }}
                      />
                      <button
                        type="button"
                        className="button_05 button_gray"
                        onClick={getEmailAuthNo}
                      >
                        {t.requestAuthCode}
                      </button>
                      {emailHint && <p className="font_red">{emailHint}</p>}
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.emailAuthCode}</th>
                  <td>
                    <form onSubmit={preventSubmit}>
                      <input
                        className="input_01"
                        type="text"
                        name=""
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={emailAuthNoInput}
                        onChange={e => {
                          const raw = e.target.value || '';
                          const digitsOnly = raw.replace(/\D/g, '');
                          setEmailCodeHint(
                            raw !== digitsOnly ? t.digitsOnly : ''
                          );
                          setEmailAuthNoInput(digitsOnly);
                        }}
                      />
                      <button
                        type="button"
                        className="button_05 button_gray"
                        onClick={validateEmailAuthNo}
                      >
                        {t.validateAuthCode}
                      </button>
                      {emailCodeHint && (
                        <p className="font_red">{emailCodeHint}</p>
                      )}
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.phoneNumber}</th>
                  <td>
                    <form onSubmit={preventSubmit}>
                      <input
                        className="input_02"
                        type="text"
                        name=""
                        maxLength={3}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={sms1}
                        onChange={e => {
                          const raw = e.target.value || '';
                          const digitsOnly = raw.replace(/\D/g, '').slice(0, 3);
                          setPhoneHint(raw !== digitsOnly ? t.digitsOnly : '');
                          setSms1(digitsOnly);
                        }}
                      />
                      -
                      <input
                        className="input_02"
                        type="text"
                        name=""
                        maxLength={4}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={sms2}
                        onChange={e => {
                          const raw = e.target.value || '';
                          const digitsOnly = raw.replace(/\D/g, '').slice(0, 4);
                          setPhoneHint(raw !== digitsOnly ? t.digitsOnly : '');
                          setSms2(digitsOnly);
                        }}
                      />
                      -
                      <input
                        className="input_02"
                        type="text"
                        name=""
                        maxLength={4}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={sms3}
                        onChange={e => {
                          const raw = e.target.value || '';
                          const digitsOnly = raw.replace(/\D/g, '').slice(0, 4);
                          setPhoneHint(raw !== digitsOnly ? t.digitsOnly : '');
                          setSms3(digitsOnly);
                        }}
                      />
                      <button
                        type="button"
                        className="button_05 button_gray"
                        onClick={getSMSAuthNo}
                      >
                        {t.requestAuthCode}
                      </button>
                      {phoneHint && <p className="font_red">{phoneHint}</p>}
                    </form>
                    <button
                      type="button"
                      onClick={() => {
                        const next = !useSamePhoneForStore;
                        setUseSamePhoneForStore(next);
                        if (next) {
                          const storeData = JSON.parse(
                            localStorage.getItem('totalStoreData') || '{}'
                          );
                          if (storeData.phone) {
                            const parts = storeData.phone.split('-');
                            if (parts.length === 3) {
                              setSms1(parts[0]);
                              setSms2(parts[1]);
                              setSms3(parts[2]);
                            }
                          }
                        }
                      }}
                      style={{
                        marginTop: 8,
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 8,
                        padding: '4px 0',
                        border: 'none',
                        background: 'none',
                        fontSize: 'inherit',
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={useSamePhoneForStore}
                        readOnly
                        style={{ pointerEvents: 'none', width: 18, height: 18 }}
                      />
                      <span>{t.sameAsAdmin}</span>
                    </button>
                  </td>
                </tr>
                <tr>
                  <th>{t.phoneAuthCode}</th>
                  <td>
                    <form onSubmit={preventSubmit}>
                      <input
                        className="input_01"
                        type="text"
                        name=""
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={mobileAuthNoInput}
                        onChange={e => {
                          const raw = e.target.value || '';
                          const digitsOnly = raw.replace(/\D/g, '');
                          setPhoneCodeHint(
                            raw !== digitsOnly ? t.digitsOnly : ''
                          );
                          setMobileAuthNoInput(digitsOnly);
                        }}
                      />
                      <button
                        type="button"
                        className="button_05 button_gray"
                        onClick={validateSMSAuthNo}
                      >
                        {t.validateAuthCode}
                      </button>
                      {phoneCodeHint && (
                        <p className="font_red">{phoneCodeHint}</p>
                      )}
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.address}</th>
                  <td>
                    <div className="signup_04">
                      <form onSubmit={preventSubmit}>
                        <input
                          className="input_01"
                          type="text"
                          id="postcode"
                          disabled
                          placeholder={t.postalCode}
                        />
                        <button
                          type="button"
                          className="button_05 button_gray"
                          onClick={getPostcode}
                        >
                          {t.searchAddress}
                        </button>
                        <br />
                        <input
                          className="input_06"
                          type="text"
                          id="roadAddress"
                          disabled
                          placeholder={t.roadAddress}
                        />
                        &ensp;
                        <input
                          className="input_06"
                          type="text"
                          id="jibunAddress"
                          disabled
                          placeholder={t.jibunAddress}
                        />
                        <br />
                        <span
                          id="guide"
                          style={{ color: '#999', display: 'none' }}
                        ></span>
                        <input
                          className="input_06"
                          type="text"
                          id="detailAddress"
                          maxLength={64}
                          placeholder={t.detailAddress}
                          value={detailAddr}
                          onChange={e => {
                            setDetailAddr(e.target.value);
                          }}
                        />
                      </form>
                      <button
                        type="button"
                        onClick={() => {
                          const next = !useSameAddrForStore;
                          setUseSameAddrForStore(next);
                          if (next) {
                            const storeData = JSON.parse(
                              localStorage.getItem('totalStoreData') || '{}'
                            );
                            const postcodeEl =
                              document.getElementById('postcode');
                            const roadEl =
                              document.getElementById('roadAddress');
                            const jibunEl =
                              document.getElementById('jibunAddress');
                            if (postcodeEl && storeData.zipCode)
                              postcodeEl.value = storeData.zipCode;
                            if (roadEl && storeData.addr)
                              roadEl.value = storeData.addr;
                            if (jibunEl && storeData.jibun)
                              jibunEl.value = storeData.jibun;
                            if (storeData.detailAddr)
                              setDetailAddr(storeData.detailAddr);
                          }
                        }}
                        style={{
                          marginTop: 8,
                          cursor: 'pointer',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 8,
                          padding: '4px 0',
                          border: 'none',
                          background: 'none',
                          fontSize: 'inherit',
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={useSameAddrForStore}
                          readOnly
                          style={{
                            pointerEvents: 'none',
                            width: 18,
                            height: 18,
                          }}
                        />
                        <span>{t.sameAsAdminAddress}</span>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t.receiveConsent}</th>
                  <td>
                    <div className="signup_05">
                      <label className="check_box">
                        {t.receiveAgree}
                        <input
                          type="checkbox"
                          name="agreement"
                          value="RA001"
                          checked={acceptAgree === 'RA001'}
                          onChange={() => handleCheckbox('RA001')}
                        />
                        <span className="check_radio"></span>
                      </label>
                      <label className="check_box">
                        {t.receiveDisagree}
                        <input
                          type="checkbox"
                          name="agreement"
                          value="RA002"
                          checked={acceptAgree === 'RA002'}
                          onChange={() => handleCheckbox('RA002')}
                        />
                        <span className="check_radio"></span>
                      </label>
                      <p className="font_gray">{t.receiveInfo}</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </article>

          <article className="button_box_01">
            <button
              type="button"
              className="button_01 button_03 button_gray_line"
              onClick={() => navigate('/store-content')}
            >
              {t.back}
            </button>
            <button
              type="button"
              className="button_01 button_03 button_gray_line"
              onClick={cancelUser}
            >
              {t.cancel}
            </button>
            <button
              type="button"
              className="button_01 button_03 button_red"
              onClick={goRegister}
            >
              {t.signup}
            </button>
          </article>
        </section>
      </main>
    </>
  );
}
